<template lang="pug">
  .container
    .header
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/liaoning/header.jpeg")
      el-form.mobile-form
        el-form-item
          el-input.txt-input(type="text", v-model="form.mobile", placeholder="请输入辽宁移动手机号")
        el-form-item(v-if="isCheckMobile")
          el-row
            el-col(:span="13")
              el-input.txt-input(type="text", placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength="6")
            el-col(:span="9", :offset="1")
              el-button(type="warning", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后可重试
    .bottom
      el-button(v-if="!isCheckMobile", @click="checkMobile") 限时领取
      el-button(v-else, @click="handleSubmit") 确定办理
    .show-more(v-if="!showMoreNotice", @click="showMoreNotice = true")
        p 点击查看活动规则
        img(src="../../../public/images/expand.png")
    .notice(v-else)
      ul
        li(v-for="(notice, index) in notices", :key="index")
          div(v-if="typeof(notice) === 'string'")
            .num {{index + 1}}.
            p.content {{notice}}
          div(v-else)
            .num {{index + 1}}.
            p.content
              | {{notice.text}}
              ul.children
                li.content(v-for="(child, idx) in notice.children", :key="idx") ({{idx + 1}}){{child}}
</template>

<script>

// 推啊=TUIA、豆盟=DOUMENG、快手=KUAISHOU
export default {
  data() {
    return {
      errlog: '',
      shareNoticeVisiable: false,
      dialogVisible: false,
      showMoreNotice: false,
      leftSendTime: 0,
      isCheckMobile: false,
      channel: 'TUIA',
      form: {
        carrierId: 10,
        mobile: '',
        verifyCode: '',
        userId: null,
        sharerId: null
      },
      notices: [
        '活动限入网时间在6个月（含）以上，已更换为4G卡、实名制的辽宁移动客户办理。',
        '活动有效期为12个月，到期后定向流量包自动失效。',
        '资费说明：15元30GB快手视频流量月付版活动：活动期间享受前4个月15元/月、第5个月起不收取任何费用，活动有效期为12个月。',
        '近三个月订购过同类APP产品的客户不支持办理本活动中同一APP的月付版活动。',
        '不同类的APP活动支持同时办理，同一类型的APP活动不支持同时办理。',
        '活动有效期内，可以变更套餐、申请过户，办理停机保号、销户、申请预销号需要本人持有效身份证到厅办理活动终止。终止活动后流量包立即失效，活动不支持再次办理。违约责任：若客户要求提前终止协议，在缴清该号码的欠费、实时话费后，需支付违约金30元。',
        '费用不计入翻倍送活动的承诺消费里。',
        {
          text: '快手APP定向流量包免流范围：快手客户端需要升级到安卓andriod5.10.1及以上、iOS 5.10.2.716及以上。访问快手APP中的直播及短视频内容。针对上述APP不包含在“定向流量”内的适用范围，特别说明如下：',
          children: [
            '客户端内上传与图片、标题/评论/消息/私信等文本信息加载、直播中礼物素材加载、第三方网页浏览以及客户自己做直播产生的流量。',
            '手机号码处于国际/港澳台地区漫游状态下产生的流量。',
            '利用手机设置代理服务器或VPN等方式，访问APP所产生的流量。',
            '用无线上网卡、平板电脑、CPE、MIFI等非手机设备使用产生的流量。',
            '手机作为热点使用产生的流量。',
            '使用CMWAP接入点方式，访问APP所产生的流量。'
          ]
        }
      ],
      selectedPackage: {},
      packageList: [
        {
          goodsCode: 'KS20200901004',
          name: '15元30GB快手视频流量月付版活动',
          desc: '',
          tips: [
            '活动限入网时间在6个月（含）以上，已更换为4G卡、实名制的辽宁移动客户办理。'
          ]
        }
      ]
    }
  },
  mounted() {
    this.handleSelected(this.packageList[0])
  },
  methods: {
    handleSelected(selectedPackage) {
      this.selectedPackage = selectedPackage
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    showConfirm() {
      this.dialogVisible = true
    },
    checkMobile() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            if (window.countLog) {
              window.countLog.ready(function() {
                window.countLog.init(function() { 
                }, {
                  isCopy: 0, 
                  pageType: 0 
                })
              })
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'commonSuccessShowAD'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scope>
.container{
  background-color: #F5BA5C;
  padding-bottom: 3.5rem;
  min-height: 50rem;
}
.header{
  .banner{
    width: 100%;
  }
}
.module-bg{
  width: 90%;
  margin: 0 auto;
  border: 2px solid #48c89f;
  border-radius: 6px;
  padding: 6px;
  background-color: #ffffff;
}
.mobile-form{
  padding: 0 48px;
  margin-top: 3rem;
}
.packages-form{
  .packages-info{
    >ul{
      display: flex;
      >li{
        flex: 1;
        font-size: .8rem;
        font-weight: bold;
        background-color: #f5f3f3;
        margin: .4rem;
        border-radius: 12px;
        >div{
          margin: .8rem .2rem;
        }
        .name{
          color: #e69a79;
        }
        .desc{
          color: #888;
        }
        &.selected{
          background-color: #88f3d1;
          .name{
            color: #e75e25;
          }
          .desc{
            color: #333;
          }
        }
      }
    }
    .tips{
      margin: 6px;
      font-size: .8rem;
      text-align: left;
      .tip{
        margin: 3px 0;
        i{
          color: #48c89f;
        }
      }
    }
  }
}
.user-notice{
  margin-top: 12px;
  font-size: .8rem;
  color: #222;
  .title{
    color: #48c89f;
    font-size: 1rem;
  }
  .content{
    text-align: left;
    margin: 6px;
    ul{
      margin-left: .4rem;
    }
  }
}
.dialog-content{
  text-align: left;
  .mobile-info{
    color: #333;
    font-weight: bold;
  }
  .package-info{
    color: #e75e25;
    font-weight: bold;
  }
}
.share-ad{
  text-align: center;
  color: #a3a3a3;
  font-size: .9rem;
  img{
    width: 94%;
  }
}
.bottom{
  width: 70%;
  // z-index: 9;
  // position: fixed;
  // bottom: 0;
  margin: 0 auto;
  margin-top: 1rem;
  height: 2.9rem;
  button{
    background-color: #FA502E;
    color: #ffffff;
    width: 100%;
    border-radius: 0;
    font-size: 1.3rem;
    border-radius: 36px;
    box-shadow: 0 3px 3px #333333;
  }
}
.txt-input{
  border-radius: 50%;
}
.show-more{
  text-align: center;
  font-size: 1.1rem;
  color: #f3f3f3;
  margin-top: 4rem;
  img{
    width: 1.5rem;
    height: 1.5rem;
    margin-top: .3rem;
  }
}
.notice{
  position: relative;
  &:after{
    position: absolute;
    background: url('../../assets/images/shaanxi/title.png') no-repeat;
    background-size: 100%;
    content: '';
    width: 14rem;
    height: 4rem;
    left: 50%;
    top: -.8rem;
    margin-left: -7rem;
  }
  background-color: #fff;
  border-radius: .4rem;
  text-align: left;
  padding: 1.5rem .8rem .6rem;
  margin: 0 1.2rem;
  margin-top: 5rem;
  font: "黑体", "Arial";
  width: 85%;
  ul{
    margin-top: 1rem;
    li{
      clear: both;
      overflow: hidden;
      font-size: .8rem;
      color: #F18020;
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
  .children{
    padding: 0;
    margin: 0;
    margin-top: .2rem;
    li{
      &.content{
        margin-left: 0;
      }
    }
  }
}
.el-form-item {
  margin-bottom: .4rem;
}
.copyright{
  border-top: 1px solid #a3a3a3;
  padding-top: .5rem;
  font-size: 0.8rem;
  color: #fff;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 4rem;
  width: 90%;
}
</style>